import { ComponentFactory, ComponentFactoryResolver, ComponentRef, Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewContainerRef } from '@angular/core';
import { LtaSvgIconComponent } from '@atl/lacerta-ui-common';

@Directive({
    selector: '[ltaPlayAudio]',
})
export class PlayAudioDirective implements OnInit, OnDestroy {
    @Input() set sound(value: {sound: string}) {
        if (value && value.sound) {
            this._sound = value.sound
            this.initIcon()
        } else if (!value) {
            if (this.playComponentRef) this.playComponentRef.destroy()
            if (this.pauseComponentRef) this.pauseComponentRef.destroy()
            if (this.currentAudio) this.currentAudio.pause()
            this.playComponentRef = null
            this.pauseComponentRef = null
        }
    }
    @Input() soundIconContainer: string = ''
    private _sound = ''
    private playComponentRef: ComponentRef<LtaSvgIconComponent>
    private pauseComponentRef: ComponentRef<LtaSvgIconComponent>

    private listenFunc: Function
    private listenFunc2: Function
    private isSoundPlaying = false
    private currentAudio: HTMLAudioElement

    constructor(
        private element: ElementRef, 
        private viewContainerRef: ViewContainerRef, 
        private componentFactoryResolver: ComponentFactoryResolver,
        private renderer: Renderer2
    ) {}

    ngOnInit(): void {
   
    }

    initIcon() {
        if (this.playComponentRef?.instance) return
        if (this.listenFunc) this.listenFunc()
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(LtaSvgIconComponent)
        this.playComponentRef = this.createIcon('play', componentFactory)
        this.pauseComponentRef = this.createIcon('pause', componentFactory)

        const host = this.element.nativeElement
        if (this.soundIconContainer) {
            const container = host.querySelector(`.${this.soundIconContainer}`)
            container.prepend(this.playComponentRef.location.nativeElement)
            container.prepend(this.pauseComponentRef.location.nativeElement)
        } else {
            host.appendChild(this.playComponentRef.location.nativeElement)
            host.appendChild(this.pauseComponentRef.location.nativeElement) 
        }
        this.renderer.setStyle(this.pauseComponentRef.location.nativeElement, 'display', 'none')

        this.listenFunc = this.renderer.listen(this.playComponentRef.location.nativeElement, 'click', (event) => {
            event.stopPropagation()
            this.currentAudio = new Audio(this._sound)
            this.currentAudio.play()
            this.renderer.setStyle(this.playComponentRef.location.nativeElement, 'display', 'none')
            this.renderer.setStyle(this.pauseComponentRef.location.nativeElement, 'display', 'flex')

            this.currentAudio.onended = () => {
                this.isSoundPlaying = false
                if (this.playComponentRef) this.renderer.setStyle(this.playComponentRef.location.nativeElement, 'display', 'flex')
                if (this.pauseComponentRef)this.renderer.setStyle(this.pauseComponentRef.location.nativeElement, 'display', 'none')
            }
        
            this.isSoundPlaying = !this.isSoundPlaying

        })

        this.listenFunc2 = this.renderer.listen(this.pauseComponentRef.location.nativeElement, 'click', (event) => {
            event.stopPropagation()

            this.currentAudio.pause()
            if (this.playComponentRef) this.renderer.setStyle(this.playComponentRef.location.nativeElement, 'display', 'flex')
            if (this.pauseComponentRef) this.renderer.setStyle(this.pauseComponentRef.location.nativeElement, 'display', 'none')
        
            this.isSoundPlaying = !this.isSoundPlaying

        })
    }

    createIcon(iconName: string, componentFactory: ComponentFactory<LtaSvgIconComponent>) {
        let ref = this.viewContainerRef.createComponent(componentFactory)
        ref.instance.size = 20
        ref.instance.icon = iconName
        this.renderer.setStyle(ref.location.nativeElement, 'cursor', 'pointer')
        this.renderer.setStyle(ref.location.nativeElement, 'color', 'var(--LTA-Colors--Primary--PB500)')
        return ref

    }

    ngOnDestroy(): void {
        if (this.listenFunc) this.listenFunc()
        if (this.listenFunc2) this.listenFunc2()
    }
}
